import React from "react";
import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import { StyledActionButton } from "./styled";

/**
 * Component for displaying confirmation dialogs for file overwrite actions
 *
 * @component
 */
/**
 * Component for displaying confirmation dialogs for file overwrite actions
 *
 * @component
 */
export const OverwriteAlert = ({ message, handleClose, isOpen, handleConfirm }) => {
  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="draggable-dialog-title"
      sx={{
        "& .MuiDialog-container": {
          backgroundColor: "rgba(0,0,0,.3)"
        },
        "& .MuiPaper-root": {
          width: "650px",
          borderRadius: "8px",
          boxShadow: "10px 10px 18px 0 rgba(0, 0, 0, 0.2)",
          backgroundColor: "#ffffff",
          "@media (max-width: 420px)": {
            overflow: "hidden",
            margin: "0 15px"
          }
        }
      }}
    >
      <DialogTitle
        id="draggable-dialog-title"
        sx={{
          textAlign: "center",
          padding: "30px 40px 10px 40px",
          "& > h2": {
            fontSize: "24px",
            fontWeight: 600,
            lineHeight: 1.33,
            letterSpacing: "normal"
          }
        }}
      >
        Are you sure?
      </DialogTitle>
      <DialogContent sx={{ padding: "8px 40px" }}>{message}</DialogContent>
      <DialogActions
        sx={{
          padding: "20px",
          justifyContent: "center",
          "& > * + *": {
            marginLeft: "20px"
          },
          "@media (max-width: 372px)": {
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }
        }}
      >
        <StyledActionButton
          onClick={handleClose}
          color="primary"
          variant="outlined"
          data-testid="cancel-button"
        >
          Cancel
        </StyledActionButton>
        <StyledActionButton
          onClick={handleConfirm}
          color="primary"
          variant="contained"
          data-testid="confirm-button"
          sx={{
            "@media (max-width: 372px)": {
              marginTop: "12px",
              marginLeft: "0 !important"
            }
          }}
        >
          Continue
        </StyledActionButton>
      </DialogActions>
    </Dialog>
  );
};

/**
 * PropTypes for OverwriteAlert component
 */
OverwriteAlert.propTypes = {
  /**
   * Message to display in the alert dialog
   */
  message: PropTypes.node.isRequired,

  /**
   * Function to handle closing the dialog
   */
  handleClose: PropTypes.func.isRequired,

  /**
   * Boolean controlling whether the dialog is open
   */
  isOpen: PropTypes.bool.isRequired,

  /**
   * Function to handle confirmation action
   */
  handleConfirm: PropTypes.func.isRequired
};
